{
  "0": {
    "workSheet": {
      "conditionalFormattings": [],
      "headerFooter": null,
      "id": 1,
      "name": "data",
      "pageSetup": {
        "fitToPage": false,
        "margins": {
          "left": 0.7,
          "right": 0.7,
          "top": 0.75,
          "bottom": 0.75,
          "header": 0.3,
          "footer": 0.3
        },
        "orientation": "portrait",
        "horizontalDpi": 4294967295,
        "verticalDpi": 4294967295,
        "pageOrder": "downThenOver",
        "blackAndWhite": false,
        "draft": false,
        "cellComments": "None",
        "errors": "displayed",
        "scale": 100,
        "fitToWidth": 1,
        "fitToHeight": 1,
        "firstPageNumber": 1,
        "useFirstPageNumber": false,
        "usePrinterDefaults": false,
        "copies": 1
      },
      "properties": {
        "defaultRowHeight": 17,
        "dyDescent": 0,
        "outlineLevelRow": 0,
        "outlineLevelCol": 0,
        "defaultColWidth": 8.83203125
      },
      "rowBreaks": [],
      "state": "visible",
      "tables": {},
      "views": [
        {
          "workbookViewId": 0,
          "rightToLeft": false,
          "state": "normal",
          "showRuler": true,
          "showRowColHeaders": true,
          "showGridLines": true,
          "zoomScale": 100,
          "zoomScaleNormal": 100,
          "activeCell": "G15"
        }
      ]
    },
    "colValidations": {},
    "rowLayouts": [
      {
        "number": 1,
        "style": {},
        "height": 20
      },
      {
        "number": 2,
        "style": {}
      },
      {
        "number": 3,
        "style": {},
        "height": 30
      },
      {
        "number": 4,
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "height": 30
      },
      {
        "number": 5,
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "height": 17
      },
      {
        "number": 6,
        "style": {}
      },
      {
        "number": 7,
        "style": {},
        "height": 30
      },
      {
        "number": 9,
        "style": {}
      },
      {
        "number": 10,
        "style": {}
      },
      {
        "number": 11,
        "style": {}
      },
      {
        "number": 12,
        "style": {}
      },
      {
        "number": 13,
        "style": {}
      },
      {
        "number": 14,
        "style": {}
      },
      {
        "number": 15,
        "style": {}
      },
      {
        "number": 16,
        "style": {}
      },
      {
        "number": 17,
        "style": {}
      }
    ],
    "colLayouts": [
      {
        "width": 2.6,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "A",
        "number": 1
      },
      {
        "width": 18,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "B",
        "number": 2
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "C",
        "number": 3
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "D",
        "number": 4
      },
      {
        "width": 32,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "E",
        "number": 5
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "F",
        "number": 6,
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 "
        }
      },
      {
        "width": 12.8,
        "isCustomWidth": true,
        "isDefault": false,
        "letter": "G",
        "number": 7,
        "style": {
          "numFmt": "#,##0_ ;[Red]-#,##0 "
        }
      }
    ],
    "cellDatas": [
      {
        "address": "B2",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": "사용자 정보",
        "col": 2,
        "row": 2
      },
      {
        "address": "K2",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 11,
        "row": 2
      },
      {
        "address": "B3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사용자 명",
        "col": 2,
        "row": 3
      },
      {
        "address": "C3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 3
      },
      {
        "address": "D3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사용자 ID",
        "col": 4,
        "row": 3
      },
      {
        "address": "E3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 3
      },
      {
        "address": "F3",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "부서",
        "col": 6,
        "row": 3
      },
      {
        "address": "G3",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 3
      },
      {
        "address": "B4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "사원 번호",
        "col": 2,
        "row": 4
      },
      {
        "address": "C4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 4
      },
      {
        "address": "D4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "직위",
        "col": 4,
        "row": 4
      },
      {
        "address": "E4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 4
      },
      {
        "address": "F4",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle",
            "wrapText": true
          }
        },
        "value": "직책",
        "col": 6,
        "row": 4
      },
      {
        "address": "G4",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 4
      },
      {
        "address": "B6",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": "검색 조건",
        "col": 2,
        "row": 6
      },
      {
        "address": "B7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "포인트 정보",
        "col": 2,
        "row": 7
      },
      {
        "address": "C7",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 3,
        "row": 7
      },
      {
        "address": "D7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "시작 기간",
        "col": 4,
        "row": 7
      },
      {
        "address": "E7",
        "style": {
          "numFmt": "mm-dd-yy",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 5,
        "row": 7
      },
      {
        "address": "F7",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": "종료 기간",
        "col": 6,
        "row": 7
      },
      {
        "address": "G7",
        "style": {
          "numFmt": "mm-dd-yy",
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "center",
            "vertical": "middle"
          }
        },
        "value": null,
        "col": 7,
        "row": 7
      },
      {
        "address": "B9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": "날짜",
        "col": 2,
        "row": 9
      },
      {
        "address": "C9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": "결제번호",
        "col": 3,
        "row": 9
      },
      {
        "address": "D9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": "사용자명",
        "col": 4,
        "row": 9
      },
      {
        "address": "E9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "vertical": "middle"
          }
        },
        "value": "사용처",
        "col": 5,
        "row": 9
      },
      {
        "address": "F9",
        "style": {
          "font": {
            "bold": true,
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "charset": 129,
            "scheme": "minor"
          },
          "border": {
            "left": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "right": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "top": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            },
            "bottom": {
              "style": "thin",
              "color": {
                "indexed": 64
              }
            }
          },
          "fill": {
            "type": "pattern",
            "pattern": "solid",
            "fgColor": {
              "argb": "FFF5F5F5"
            },
            "bgColor": {
              "indexed": 64
            }
          },
          "alignment": {
            "horizontal": "right",
            "vertical": "middle"
          }
        },
        "value": "사용금액",
        "col": 6,
        "row": 9
      },
      {
        "address": "C10",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 10
      },
      {
        "address": "C11",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 11
      },
      {
        "address": "C12",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 12
      },
      {
        "address": "C13",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 13
      },
      {
        "address": "C14",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 14
      },
      {
        "address": "C15",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 15
      },
      {
        "address": "C16",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 16
      },
      {
        "address": "C17",
        "style": {
          "font": {
            "size": 11,
            "color": {
              "theme": 1
            },
            "name": "맑은 고딕",
            "family": 2,
            "scheme": "minor"
          },
          "border": {},
          "fill": {
            "type": "pattern",
            "pattern": "none"
          },
          "alignment": {
            "horizontal": "left"
          }
        },
        "value": null,
        "col": 3,
        "row": 17
      }
    ],
    "images": []
  },
  "workbook": {
    "created": "2024-12-10T02:20:17.000Z",
    "creator": "",
    "lastModifiedBy": "",
    "modified": "2024-12-10T07:39:17.000Z",
    "views": [
      {
        "x": 0,
        "y": 500,
        "width": 35840,
        "height": 20620,
        "visibility": "visible"
      }
    ],
    "properties": {
      "date1904": false
    }
  }
}